import { render, staticRenderFns } from "./performanceV2.vue?vue&type=template&id=470239da&scoped=true"
import script from "./performanceV2.vue?vue&type=script&lang=js"
export * from "./performanceV2.vue?vue&type=script&lang=js"
import style0 from "./performanceV2.vue?vue&type=style&index=0&id=470239da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470239da",
  null
  
)

export default component.exports